export const PROD_DOMAIN = 'chicoree.ch';
export const STAGE_DOMAIN = 'fe-staging.chicoree.ch';
export const ALLOWED_DOMAIN_REGEXP = new RegExp(`^([^.]+\\.)?${PROD_DOMAIN}$`);
export const PREFIXED_INTERNAL_LINK_DOMAINS = [PROD_DOMAIN, STAGE_DOMAIN].map(
  item => `/${item}`,
);
